import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=0b8c3a0e&scoped=true&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=0b8c3a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c3a0e",
  null
  
)

export default component.exports